module.exports = __webpack_public_path__ + "dm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/dm.svg
// module id = 776
// module chunks = 0